import { render, staticRenderFns } from "./AddUpdate.vue?vue&type=template&id=fbf0be52"
import script from "./AddUpdate.vue?vue&type=script&lang=js"
export * from "./AddUpdate.vue?vue&type=script&lang=js"
import style0 from "./AddUpdate.vue?vue&type=style&index=0&id=fbf0be52&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports